<template lang="pug">
  SspLayout(area="tnt")
    template(slot="actions")
      label.show-deleted(for="deleted") Show deleted: &nbsp;
        input(type="checkbox" id="deleted" v-model="deleted" @change="fetchData()")
      router-link.btn.btn-primary.new-package-type-button(:to="{ name: 'packageNew' }") New package
        span.ml5
        i.fa.fa-plus

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th ID
        th Name
        th Type
        th Material
        th Dry Weight
        th Max gross weight
        th Description
        th
      tr(v-for="p in packageTypes")
        td {{ p.id }}
        td {{ p.name }}
        td {{ p.type }}
        td {{ p.material }}
        td {{ p.tareWeight }}
        td {{ p.maxGrossWeight }}
        td {{ p.description }}
        td.actions
          a.btn-edit(title="Edit package" @click="goToPackageType(p.id)")
          a.btn-trash(title="Delete package" @click="remove(p.id)" v-if="!p.deleted")
          a.btn-restore(title="Restore package" @click="undelete(p.id)" v-if="p.deleted")
</template>

<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Masterdata from '@/service/apis/Masterdata'

export default {
  data: () => ({
    packageTypes: [],
    deleted: false
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      if (this.deleted) {
        req.deleted = this.deleted
      }
      return Masterdata.listPackageTypes(req)
        .then((resp) => {
          this.packageTypes = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    },
    remove(id) {
      this.$confirm({ text: 'Are you sure you want to delete this package?' })
        .then((conf) => {
          if (conf) {
            Masterdata.deletePackageType(id)
              .then(() => {
                miniToastr.success('Package was deleted')
                this.fetchData()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    },
    goToPackageType(id) {
      this.$router.push({ name: 'packageEdit', params: { id } })
    },
    undelete(id) {
      this.$confirm({ text: 'Are you sure you want to undelete this package?' })
        .then((conf) => {
          if (conf) {
            Masterdata.undeletePackageType(id)
              .then(() => {
                miniToastr.success('Package was undeleted')
                this.fetchData()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>
<style scoped>
.show-deleted {
  margin-top: 7px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/package/PackageTypes.vue